/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ElIconModule } from '../icon/icon.module';
import { ElAccordionComponent } from './accordion.component';
import { ElAccordionItemComponent } from './accordion-item.component';
import { ElAccordionItemHeaderComponent } from './accordion-item-header.component';
import { ElAccordionItemBodyComponent } from './accordion-item-body.component';

const EL_ACCORDION_COMPONENTS = [
  ElAccordionComponent,
  ElAccordionItemComponent,
  ElAccordionItemHeaderComponent,
  ElAccordionItemBodyComponent,
];

@NgModule({
  imports: [CommonModule, ElIconModule],
  exports: [...EL_ACCORDION_COMPONENTS],
  declarations: [...EL_ACCORDION_COMPONENTS],
  providers: [],
})
export class ElAccordionModule {}
